import React from 'react';
import { useTranslation } from 'react-i18next';
// @dynamic-i18n-keys
// Dynamic t() at line 33 (studio.orders.status.${status}):
//   studio.orders.status.pending
//   studio.orders.status.in_progress
//   studio.orders.status.completed
//   studio.orders.status.canceled
import cn from 'classnames';
import { PapiOriginalsResponse } from '@wix/da-papi-types';
import StudioScheduled from '@wix/da-ds/pkg/Icons/16x16/StudioScheduled';
import Refresh from '@wix/da-ds/pkg/Icons/16x16/Refresh';
import Complete from '@wix/da-ds/pkg/Icons/16x16/Complete';
import NotAllowed from '@wix/da-ds/pkg/Icons/16x16/NotAllowed';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './OrderStatusDisplay.scss';

interface Props {
  status: PapiOriginalsResponse['status'];
}

const OrderStatusDisplay: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <span className={cn(s['root'], s[`status-${status}`])}>
      {status === 'pending' && (
        <StudioScheduled size={IconSize.SMALL} disableDefaultColors />
      )}
      {status === 'in_progress' && (
        <Refresh size={IconSize.SMALL} disableDefaultColors />
      )}
      {status === 'completed' && (
        <Complete size={IconSize.SMALL} disableDefaultColors />
      )}
      {status === 'rejected' && (
        <NotAllowed size={IconSize.SMALL} disableDefaultColors />
      )}
      {t(`studio.orders.status.${status}`)}
    </span>
  );
};
OrderStatusDisplay.displayName = 'OrderStatusDisplay';

export default OrderStatusDisplay;
